
@if (_isShow) {
  <p>画像の切り抜き範囲を選択してください。</p>
  @if (aspectRatio) {
    <div>
      <image-cropper class="image-cropper"
        [imageChangedEvent]="imageChangeEvent"
        [aspectRatio]="aspectRatio"
        [maintainAspectRatio]="maintainAspectRatio"
        [resizeToWidth]="maxWidth"
        [resizeToHeight]="maxHeight"
        [alignImage]="'left'"
        [imageQuality]="90"
        [backgroundColor]="'#FFFFFF'"
        [format]="format"
        (imageLoaded)="imageLoaded()"
        (imageCropped)="imageCropped($event)"
        (loadImageFailed)="loadImageFailed()"
      ></image-cropper>
    </div>
  }
}

@if (_isShow && !isLoaded) {
  <div class="loading"></div>
}

